import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { deleteVoiceAndTextSnippets } from './voiceSnippetSlice';
import axios from 'axios';
import { config } from '../constants/config'

export const fetchTextSnippets = createAsyncThunk(
  'textSnippets/fetchTextSnippets',
  async ({ userId, folderName, fileName, version }) => {
    let query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}`
    if (fileName && version) query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}/${version}`
    else if (fileName) query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}`
    const response = await axios.get(query);
    return response.data;
  }
);

export const deleteTextSnippet = createAsyncThunk(
  'textSnippets/deleteTextSnippet',
  async ({ userId, uuid, s3TextUrl }) => {
    let s3TextUrlEscaped = encodeURIComponent(s3TextUrl);
    const response = await axios.delete(`${config.GET_API_TEXT_SNIPPETS}/${userId}/${uuid}/${s3TextUrlEscaped}`);
    return response.data;
  }
);

export const addTextSnippet = createAsyncThunk(
  'textSnippets/addTextSnippet',
  async ({ userId, fileName, variation, s3TextUrl, version, uuid }) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      const instance = axios.create({
        baseURL: config.BASE_URL,  // specify your base URL
        headers: { 'Authorization': `Bearer ${token}` }
      });

      try {
        const response = await instance.post(config.ADD_API_TEXT_SAMPLE_META_DATA, { userId, fileName, variation, s3TextUrl, version, uuid });
        return response.data;
      } catch (error) {
        console.error('Error saving text snippet:', error.response.data);
      }
    }
    else {
      console.error('Error saving text snippet: Invalid user token');
    }
  }
);

const selectTextSnippetsState = state => state.user.textSnippets;

export const selectAlltextSnippets = createSelector(
  selectTextSnippetsState,
  (textSnippetsState) => {
    if (textSnippetsState.fetchTextstatus === "succeeded" ||
      textSnippetsState.addTextstatus === "succeeded") {
      try {
        return textSnippetsState.snippets.snippets;
      } catch (e) {
        console.error('No snippets', e.message);
        return [];
      }
    }
    else {
      // console.error('Current textSnippets.fetchTextstatus', textSnippetsState.fetchTextstatus);
      return [];
    }
  }
);




const textSnippetSlice = createSlice({
  name: 'textSnippets',
  initialState: {
    snippets: [],
    sharedUrl: null,
    status: 'idle',
    addTextstatus: 'idle',
    deleteTextstatus: 'idle',
    fetchTextstatus: 'idle',
    deleteVoiceAndTextStatus: 'idle',
    error: null,
  },
  reducers: {
    shareSignedUrl: (state, action) => {
      state.sharedUrl = action.payload;
    },
    snippetCopyDetails: (state, action) => {
      state.snippetCopyDetails = action.payload;
    },
    snippetVoiceRecorderClearAction: (state, action) => {
      state.snippetVoiceRecorderClear = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTextSnippets.pending, (state) => {
        state.fetchTextstatus = 'loading';
      })
      .addCase(fetchTextSnippets.fulfilled, (state, action) => {
        state.fetchTextstatus = 'succeeded';
        state.snippets = action.payload;
      })
      .addCase(fetchTextSnippets.rejected, (state, action) => {
        state.fetchTextstatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(addTextSnippet.pending, (state) => {
        state.addTextstatus = 'loading';
      })
      .addCase(addTextSnippet.fulfilled, (state, action) => {
        state.addTextstatus = 'succeeded';
        state.snippets = action.payload;
      })
      .addCase(addTextSnippet.rejected, (state, action) => {
        state.addTextstatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteTextSnippet.pending, (state) => {
        state.deleteTextstatus = 'deleting';
      })
      .addCase(deleteTextSnippet.fulfilled, (state, action) => {
        state.deleteTextstatus = 'succeeded';
        state.snippets = action.payload;
      })
      .addCase(deleteTextSnippet.rejected, (state, action) => {
        state.deleteTextstatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteVoiceAndTextSnippets.pending, (state) => {
        state.deleteVoiceAndTextStatus = 'deleting';
      })
      .addCase(deleteVoiceAndTextSnippets.fulfilled, (state, action) => {
        state.deleteVoiceAndTextStatus = 'succeeded';
        state.snippets = action.payload.textDelResponse;
      })
      .addCase(deleteVoiceAndTextSnippets.rejected, (state, action) => {
        state.deleteVoiceAndTextStatus = 'failed';
        state.error = action.error.message;
      });
    ;
  },
});


export const { shareSignedUrl, snippetCopyDetails, snippetVoiceRecorderClearAction } = textSnippetSlice.actions
export default textSnippetSlice.reducer;

export const selectShareSignedUrl = (state) => state.user.textSnippets && state.user.textSnippets.shareSignedUrl;
export const selectAllTextSnippets = (state) => state.user.textSnippets && state.user.textSnippets.snippets && state.user.textSnippets.snippets.snippets;
export const selectTextSnippetsStatus = (state) => state.user.textSnippets.status;
